import React from "react";
import { Switch } from "antd";
import { useTranslation } from "react-i18next";
import "./LanguageSwitcher.less";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const toggleLang = (checked) => {
    const nextLang = checked ? "en" : "vi";
    i18n.changeLanguage(nextLang);
  };

  const currentLang = i18n.language;

  return (
    <div className="language-switcher">
      <Switch
        checked={currentLang === "en"}
        onChange={toggleLang}
        checkedChildren="EN"
        unCheckedChildren="VI"
        className={`language-switch lang-${currentLang}`}
      />
    </div>
  );
};

export default LanguageSwitcher;
